<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            Card Details
            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="addCard()"
              >Add new</CButton
            >
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            pagination
            clickable-rows
            hover
          >
            <template #description="{ item }">
              <td>
                {{ item.description.substring(0, 10) + "..." }}
              </td>
            </template>
            <template #detail="{ item }">
              <td>
                {{ item.detail.substring(0, 10) + "..." }}
              </td>
            </template>
            <template #location="{ item }">
              <td>
                <span v-for="items in item.location" :key="items"
                  >{{ items.label }}<br
                /></span>
              </td>
            </template>
            <template #img="{ item }">
              <td @click="editToken(item)">
                <!-- <span v-for="items in item.location" :key="items"
                  >{{ items.label }}<br
                /></span> -->
                 <!-- v-if="image1" -->
                <img
                  :src="item.img"
                  style="width: 50px; border-radius: 50px; height: 50px"
                />
                  <!-- <img v-else
                  src="img/noimage.png"
                  style="width: 50px; border-radius: 50px; height: 50px"
                /> -->
              </td>
            </template>
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item, index)"
                >
                  Edit </CButton
                ><br /><br />
                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="deleteRoute(item, index)"
                >
                  Delete
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../../App.vue";
import firebase from "firebase";
const db = firebase.firestore();
export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          key: "img",
          sortable: true,
        },

        {
          key: "name",
          sortable: true,
        },
        {
          key: "detail",
          sortable: true,
        },
           {
          key: "description",
          sortable: true,
        },
      

        // {
        //   label: "Action",
        //   key: "ActionView"
        // }
      ],

      speciesCode: null,
      speciesName: "",
      documentId: "",
      tableData: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      image1:false
    };
  },
  methods: {
    addCard() {
      this.$router.push({ name: "addCard" });
    },
    editToken(item, index) {
      console.log("edit token item", item);
      console.log("Edit token index", index);
      this.$router.push({ name: "editToken", params: { id: item.id } });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    getproduct() {
       APIService.getproducts().then(
          (res) => {
            if (res.status == 200) {
              console.log("data",res.data)
              this.tableData = res.data;
            }
          })
     
    },
    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
      // this.$router.push({ name: "editToken", params: { id: this.documentId } });
      // this.editSpecies = item;
      // this.speciesCode = item.speciesCode;
      // this.speciesName = item.speciesName;
      // this.addButton = false;
      // this.saveButton = true;
      // this.deleteButton = true;
      // this.cancelButton = false;
      // this.addnewButton = true;
      // this.EditsaveButton = false;
    },

    deleteRoute(item) {
      console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails1")
        .doc(this.documentId)
        .delete()
        .then(() => {
          // console.log("Document successfully deleted!");
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.getproduct();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>